import API from './API/Main/API';
import { login, refresh } from './State/identitySlice/accountSlice';
import { resetState } from './resetState';

const localStorageMiddleware = (store: any) => (next: any) => (action: any) => {
	const { dispatch } = store;
	const ls = window.localStorage;

	if (action.type === login.fulfilled.type) {
		if (action.payload.token) {
			API.setToken(action.payload.token);
		}
	}

	if (action.type === refresh.fulfilled.type) {
		if (action.payload.token) {
			API.setToken(action.payload.token);
		}
	}

	if (action.type === refresh.rejected.type) {
		dispatch(resetState());
	}

	if (action.type === resetState.type) {
		const appVersion = ls.getItem('appVersion');
		const loggedUserId = ls.getItem('userId');
		ls.clear();
		ls.setItem('appVersion', appVersion as string);
		ls.setItem('userId', loggedUserId as string);
		API.setToken('');
	}

	next(action);
};

export { localStorageMiddleware };
